import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { LOCALE_PATH } from './utils/configUtil';

export const ENGLISH_LANGUAGE = 'en';
export const RUSSIAN_LANGUAGE = 'ru';
export const DEFAULT_LANGUAGE = RUSSIAN_LANGUAGE;

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    returnNull: false,
    cleanCode: true,
    backend: {
      loadPath: LOCALE_PATH,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
